import { useMutation, useQuery, useQueryClient } from "react-query";
import { apiCall } from "Apis/BaseApi";
import { IPaginatedList } from "Apis/Models/IPaginatedList";
import { IInventoryItemDto } from "./Models/IInventoryItemDto";
import {IQueryParams} from "./Models/IQueryParams";

export const INVENTORY_ITEMS_CACHE_KEY = 'INVENTORY_ITEMS_CACHE_KEY '
export const useInventoryItems = (queryable: Partial<IQueryParams> | null = null) => {

    return useQuery<IPaginatedList<IInventoryItemDto>>([INVENTORY_ITEMS_CACHE_KEY, queryable], async () => {
        return await apiCall<IPaginatedList<IInventoryItemDto>>({
            url: `/inventory`,
            method: 'GET',
            queryParams: queryable
        })
    });
}

export const useUnlistInventoryItem = () => {

    const queryClient = useQueryClient();

    return useMutation(async (inventoryItem: IInventoryItemDto): Promise<IInventoryItemDto> => {
        return await apiCall<IInventoryItemDto>({
            url: `/inventory/${inventoryItem.id}/unlist`,
            method: 'PUT',
        })
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(INVENTORY_ITEMS_CACHE_KEY)
        }
    })
}
